import CatalogView from './CatalogView';

export default CatalogView;
